import type { ComponentType, SVGProps } from 'react';

import OneMentorMenuLogoIcon from '../components/icons/svg/OneMentorMenuLogoIcon';
import OneMentorWizardLogoIcon from '../components/icons/svg/OneMentorWizardLogoIcon';
import icons from '../constants/icons';

export interface ILogoDetails {
  url?: string;
  component?: ComponentType<SVGProps<SVGSVGElement>>;
}

export interface IGetLogo {
  shared?: ILogoDetails;
  specific?: {
    wizard?: ILogoDetails;
    home?: ILogoDetails;
  };
}

export const getLogoWhiteLabel = (customLogo?: IGetLogo, isWizard?: boolean): ILogoDetails => {
  const getDefaultLogo = (): ILogoDetails =>
    isWizard ? { component: OneMentorWizardLogoIcon } : { component: OneMentorMenuLogoIcon };

  if (!customLogo) {
    return getDefaultLogo();
  }

  const specificLogo = isWizard ? customLogo.specific?.wizard : customLogo.specific?.home;

  if (specificLogo) {
    return specificLogo;
  }

  const sharedLogo = customLogo.shared;

  if (sharedLogo?.url === icons.DEFAULT_ICON) {
    return getDefaultLogo();
  }

  return sharedLogo || getDefaultLogo();
};
